const SecContent = () => {
  return (
    <div className="col-12 col-md-7">
      {/* Content Info */}
      <div className="contact_info_area d-sm-flex justify-content-between">
        <div
          className="contact_info text-center wow fadeInUp py-2"
          data-wow-delay="0.2s"
        >
          <h5>NAVIGATE</h5>
          <a href="https://anonydoxx.network">
            <p>Home</p>
          </a>
          <a href="https://verify.validentry.com" target="_blank" rel="noreferrer">
            <p>Vault Verification</p>
          </a>
          <a href="https://anonydoxx.io/" target="_blank" rel="noreferrer">
            <p>Website</p>
          </a>
          <a href="/policy">
            <p>Privacy Policy</p>
          </a>
          <a href="/terms">
            <p>Terms and Conditions</p>
          </a>
        </div>
        {/* Content Info */}

        {/* Content Info */}
        <div
          className="contact_info text-center wow fadeInUp py-2"
          data-wow-delay="0.4s"
        >
          <h5>Contact</h5>
          <p>security@anonydoxx.io</p>
        </div>
      </div>
    </div>
  );
};

export default SecContent;
